import { Component, OnInit, Input } from "@angular/core";
import { RatingDistribution } from "./interfaces";
import { ConsensusSummaryDataService } from "./consensus-summary-data.service";
import { catchError } from "rxjs/operators";
import { Subscription, throwError } from "rxjs";
@Component({
  selector: "app-consensus-summary",
  templateUrl: "./consensus-summary.component.html",
  styleUrls: ["./consensus-summary.component.scss"],
})
export class ConsensusSummaryComponent implements OnInit {
  @Input() primaryTicker = "";
  constructor(private dataService: ConsensusSummaryDataService) {}

  summary: any = {};
  ticker = "";
  ratingDistribution: RatingDistribution[];
  hasConsensus = false;
  brokerInTPConsensus: number;
  brokerInRatingConsensus: number;
  totalBroker: number;
  sumOfBrokerWithBuyHoldSellRating: number;
  tprConsensusDataReady = false;

  //subscribers
  tprConsensusSummarySubsciber: Subscription;

  ngOnInit() {
    this.getTprConsensusSummary();
  }

  getTprConsensusSummary = (): void => {
    this.tprConsensusDataReady = false;
    this.tprConsensusSummarySubsciber = this.dataService
      .getTprConsensusSummary(this.primaryTicker)
      .pipe(
        catchError((err) => {
          console.error(err);
          return throwError(err);
        }),
      )
      .subscribe((response: any) => {
        if (response && response["status"] === "success") {
          this.summary = response["data"][this.primaryTicker];
          this.hasConsensus = this.summary["has_current_consensus"];
          this.brokerInTPConsensus = this.summary["broker_in_tp_consensus"];
          this.brokerInRatingConsensus =
            this.summary["broker_in_rating_consensus"];
          this.totalBroker = this.summary["total_no_of_broker"];
          this.sumOfBrokerWithBuyHoldSellRating =
            (this.summary["broker_with_buy_rating"] || 0) +
            (this.summary["broker_with_hold_rating"] || 0) +
            (this.summary["broker_with_sell_rating"] || 0);
          this.ratingDistribution = [
            {
              name: `Buy`,
              color: "#006800",
              y: this.summary["broker_with_buy_rating"],
              percent: this.summary["buy_broker_percent"],
              id: 1,
              selected: false,
              sliced: false,
            },
            {
              name: "Hold",
              color: "#ffc846",
              y: this.summary["broker_with_hold_rating"],
              percent: this.summary["hold_broker_percent"],
              id: 2,
              selected: false,
              sliced: false,
            },
            {
              name: "Sell",
              color: "#b40000",
              y: this.summary["broker_with_sell_rating"],
              percent: this.summary["sell_broker_percent"],
              id: 3,
              selected: false,
              sliced: false,
            },
          ];
          this.tprConsensusDataReady = true;
        }
      });
  };

  ngOnDestroy() {
    if (this.tprConsensusSummarySubsciber) {
      this.tprConsensusSummarySubsciber.unsubscribe();
    }
  }
}
